import { useAppDispatch } from "@/app/store/hooks";
import type { ProjectPlanType } from "@/entities/projects/model/types";
import { FeedbackForm } from "@/features/feedbacks/ui/FeedbackForm";
import TransparentButton from "@/shared/ui/buttons/TransparentButton";
import { SectionLayout } from "@/shared/ui/layouts/SectionLayout";
import Typography from "@/shared/ui/Typography";
import { complatedModalOpen } from "@/widgets/modal/model/slice";
import { PlanSlider } from "@/widgets/sliders/plan_slider/ui/PlanSlider";

export interface IProjectPlanSectionProps {
    planning: ProjectPlanType;
}

export function ProjectPlanSection({ planning }: IProjectPlanSectionProps) {

    const dispatch = useAppDispatch()

    const handleDownloadPlan = (name: string, phone: string) => {

        // send data logic
        console.log(name, phone);

        const link = document.createElement("a");
        link.href = planning.presentationLink;
        link.download = "";
        link.target = "_blank";
        link.rel = "noopener noreferrer";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        dispatch(complatedModalOpen(planning.presentationLink))

    }

    return (
        <SectionLayout 
            className="bg-blue"
            containerClassName="py-[40px] flex flex-col gap-[20px] md:gap-[28px]"
        >
            <div className="flex flex-col gap-[20px] md:gap-[28px]">
                <TransparentButton className="h-[34px] px-[10px] text-[14px] md:text-[14px] font-normal text-white bg-white-20 w-fit cursor-default">
                    Варианты планировок
                </TransparentButton>
                <div className="flex flex-row justify-center gap-[20px] md:flex-row">
                    <div
                        className="hidden md:flex bg-no-repeat bg-cover bg-center flex-1 rounded-[10px]"
                        style={{backgroundImage: `url(${planning.imageUrl})`}}
                    />
                    <PlanSlider
                        images={planning.schemas}
                    />
                </div>
            </div>



            <div className="flex flex-col gap-[20px]">
                <Typography tag="h2" className="text-white">
                    Получите полный каталог планировок
                </Typography>
                <FeedbackForm
                    bgBlue={true}
                    download
                    onSubmit={handleDownloadPlan}
                />
            </div>
        </SectionLayout>
    )        
}
